import { render, staticRenderFns } from "./DetailService.vue?vue&type=template&id=43748f5a&"
import script from "./DetailService.vue?vue&type=script&lang=js&"
export * from "./DetailService.vue?vue&type=script&lang=js&"
import style0 from "./DetailService.vue?vue&type=style&index=0&id=43748f5a&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43748f5a')) {
      api.createRecord('43748f5a', component.options)
    } else {
      api.reload('43748f5a', component.options)
    }
    module.hot.accept("./DetailService.vue?vue&type=template&id=43748f5a&", function () {
      api.rerender('43748f5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DetailService.vue"
export default component.exports